<template>
  <div v-if="data" class="DailySentence_child">
    <WordDictM v-if="(dictIdx !== -1 || dictIdxJp !== -1)" v-on:closeDict="closeDict" class="md:hidden" :content="popupData" />
    <div>
      <!-- 中文 -->
      <div class="chinese border-gray-500 text-base" :class="{ 'border-b mb-4 pb-4': (isShowJp && data.jp && data.jp.english) || (isShowEn && data.english) }">
        <p>【{{ data.category_name }}】{{ data.local }}</p>
      </div>

      <!-- 日文 -->
      <div class="flex md:items-center" v-if="data.jp && data.jp.english && isShowJp" :class="{ 'mb-4': isShowEn }">
        <a class="cursor-pointer block mr-2" @click="PlayAudioJp()" v-if="data.jp.audio_url">
          <font-awesome-icon :icon="['far', 'pause-circle']" class="text-2xl" v-if="isPlayingJp"/>
          <font-awesome-icon :icon="['far', 'play-circle']" class="text-2xl" v-else />
          <audio :id="'audioJp'" :src="data.jp.audio_url" :ref="'audioplayerJp'"></audio>
        </a>
        <a class="cursor-pointer block mr-2 text-gray-400" v-else>
          <font-awesome-icon :icon="['far', 'play-circle']" class="text-2xl" />
        </a>
        <p class="english whitespace-normal text-NotoSansRegular">
          <span class="jpWord relative text-base whitespace-normal" v-for="(child, idx) in spiltSentenceJP" :key="idx"
            @click.prevent.stop="setIdxJp(child, idx)"
            :class="{ 'enWord': !isRegular(child), 'cursor-pointer showDictJp whitespace-pre-wrap': dictDataJp.findIndex(x => x.key === child) > -1 && dictDataJp[dictDataJp.findIndex(x => x.key.toLowerCase() === child.toLowerCase())].underline, 'cursor-pointer': dictDataJp.findIndex(x => x.key === child) > -1 }">
            <span v-html="forceToJap(child)" class="whitespace-normal"></span>
            <WordDict class="hidden md:block" v-if="dictIdxJp === idx && ductWordJp" v-on:closeDict="closeDict"
              :content="ductWordJp" v-click-outside="closeDict" />
          </span>
        </p>
      </div>

      <!-- 英文 -->
      <div class="flex md:items-center flex-1" v-if="isShowEn">
        <a class="cursor-pointer block mr-2" @click="PlayAudioEn()" v-if="data.audio_url">
          <font-awesome-icon :icon="['far', 'pause-circle']" class="text-2xl" v-if="isPlayingEn" />
          <font-awesome-icon :icon="['far', 'play-circle']" class="text-2xl" v-else />
          <audio id="'audioEn'" :src="data.audio_url" ref="audioplayerEn"></audio>
        </a>
        <a class="cursor-pointer block mr-2 text-gray-400" v-else>
          <font-awesome-icon :icon="['far', 'play-circle']" class="text-2xl" />
        </a>
        <div>
          <p class="english text-base text-NotoSansRegular">
            <span class="relative leading-loose text-NotoSansRegular" v-for="(child, idx) in spiltSentenceEn" :key="idx" @click.prevent.stop="setIdxEn(child, idx)"
              :class="{ 'enWord': !isRegular(child),  'showDict cursor-pointer textColorRed': dictDataEn.findIndex(x => x.key.toLowerCase() === child.toLowerCase()) > -1 && dictDataEn[dictDataEn.findIndex(x => x.key.toLowerCase() === child.toLowerCase())].underline, 'cursor-pointer': dictDataEn.findIndex(x => x.key.toLowerCase() === child.toLowerCase()) > -1 }"
            >{{ child }}
              <WordDict class="hidden md:block" v-if="dictIdx === idx" v-on:closeDict="closeDict"
              :content="ductWord" v-click-outside="closeDict" />
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'
import WordDict from '@/components/company/WordDict'
import WordDictM from '@/components/company/WordDict_m'
import langMixin from '@/components/modules/langMixin'
export default {
  name: 'DailySentence_Item',

  data () {
    return {

      dictIdx: -1,
      dictIdxJp: -1,

      ductWord: null,
      ductWordJp: null,

      isPlayingEn: false,
      isPlayingJp: false,

      temporString: null
    }
  },

  props: {
    data: {
      type: Object
    },
    isShowEn: {
      type: Boolean
    },
    isShowJp: {
      type: Boolean
    }
  },
  mixins: [
    langMixin
  ],
  computed: {
    spiltSentenceEn () {
      let self = this
      if (self.data && self.data.english) {
        if (self.data.dict && self.dictDataEn && self.dictDataEn.length > 0) {
          const str = self.data.english
          const splitStr = self.data.english.split('')
          let strArr = []
          let newArr = []
          let index = 0
          for (let i = 0; i < self.dictDataEn.length; i++) {
            strArr.push(str.slice(index, self.dictDataEn[i].char_index).trim())
            // strArr.push(self.dictDataEn[i].key)
            strArr.push(splitStr.slice(self.dictDataEn[i].char_index, self.dictDataEn[i].char_index + self.dictDataEn[i].char_length).join('').trim())

            index = self.dictDataEn[i].char_index + self.dictDataEn[i].char_length
          }
          if (self.dictDataEn[self.dictDataEn.length - 1].char_index + self.dictDataEn[self.dictDataEn.length - 1].char_length < str.length) {
            let idx = self.dictDataEn.length - 1
            let begin = self.dictDataEn[idx].char_index + self.dictDataEn[idx].char_length
            strArr.push(str.slice(begin, str.length))
          }

          for (let j = 0; j < strArr.length; j++) {
            if (strArr[j].length > 0) {
              newArr.push(strArr[j])
            }
          }

          // newArr[0] = self.format_en_title(newArr[0])
          return newArr
        } else {
          return [self.data.english]
        }
      } else {
        return []
      }
    },

    spiltSentenceJP () {
      let self = this
      if (self.data && self.data.jp && self.data.jp.english) {
        if (self.data.jp.dict && self.dictDataJp && self.dictDataEn.length > 0) {
          const str = self.data.jp.english
          let strArr = []
          let newArr = []
          let index = 0
          for (let i = 0; i < self.dictDataJp.length; i++) {
            strArr.push(str.slice(index, self.dictDataJp[i].char_index).trim())
            strArr.push(self.dictDataJp[i].key.trim())

            index = self.dictDataJp[i].char_index + self.dictDataJp[i].char_length
          }
          if (self.dictDataJp[self.dictDataJp.length - 1].char_index + self.dictDataJp[self.dictDataJp.length - 1].char_length < str.length) {
            let idx = self.dictDataJp.length - 1
            let begin = self.dictDataJp[idx].char_index + self.dictDataJp[idx].char_length
            strArr.push(str.slice(begin, str.length))
          }

          for (let j = 0; j < strArr.length; j++) {
            if (strArr[j].length > 0) {
              newArr.push(strArr[j])
            }
          }
          return newArr
        } else {
          return [self.data.jp.english]
        }
      } else {
        return []
      }
    },

    dictDataEn () {
      if (this.data) {
        return this.compare(this.data.dict)
      } else {
        return []
      }
    },

    dictDataJp () {
      if (this.data.jp) {
        return this.compare(this.data.jp.dict)
      } else {
        return []
      }
    },

    popupData () {
      if (this.dictIdxJp !== -1 && this.ductWordJp) {
        return this.ductWordJp
      } else if (this.dictIdx !== -1 && this.ductWord) {
        return this.ductWord
      } else {
        return null
      }
    }
  },
  directives: {
    ClickOutside
  },
  components: {
    WordDict,
    WordDictM
  },
  mounted () {
  },
  methods: {
    compare (array) {
      if (array) {
        return array.sort((a, b) => a.char_index > b.char_index ? 1 : -1)
      } else {
        return []
      }
    },
    async setIdxJp (child, idx) {
      let self = this
      self.dictIdx = -1
      self.ductWord = null

      let dictIndex = self.dictDataJp.findIndex(x => x.key === child)

      if (dictIndex > -1) {
        self.ductWordJp = self.dictDataJp[dictIndex]
        self.dictIdxJp = idx
      }
    },
    closeDict () {
      this.dictIdx = -1
      this.dictIdxJp = -1
    },

    async setIdxEn (child, idx) {
      let self = this
      self.dictIdxJp = -1
      self.ductWordJp = null

      let dictIndex = self.dictDataEn.findIndex(x => x.key.toLowerCase() === child.toLowerCase())

      if (dictIndex > -1) {
        self.ductWord = self.dictDataEn[dictIndex]
        self.dictIdx = idx
      }
    },
    async PlayAudioJp () {
      let self = this
      await self.pauseAudio()
      if (self.$refs.audioplayerJp) {
        let audioplayer = self.$refs.audioplayerJp
        // 判斷是否撥放中
        audioplayer.onplaying = () => {
          self.isPlayingJp = true
        }
        audioplayer.onpause = () => {
          self.isPlayingJp = false
        }
        // 播放切換
        if (self.isPlayingJp) {
          audioplayer.pause()
          audioplayer.currentTime = 0
          self.isPlayingJp = false
        } else {
          audioplayer.play()
          self.isPlayingJp = true
        }
      }
    },
    async PlayAudioEn () {
      let self = this
      await self.pauseAudio()
      if (self.$refs.audioplayerEn) {
        let audioplayer = self.$refs.audioplayerEn
        // 判斷是否撥放中
        audioplayer.onplaying = () => {
          self.isPlayingEn = true
        }
        audioplayer.onpause = () => {
          self.isPlayingEn = false
        }
        // 播放切換
        if (self.isPlayingEn) {
          audioplayer.pause()
          audioplayer.currentTime = 0
          self.isPlayingEn = false
        } else {
          audioplayer.play()
          self.isPlayingEn = true
        }
      }
    },
    pauseAudio () {
      let self = this
      if (self.$refs.audioplayerEn) {
        self.$refs.audioplayerEn.pause()
        self.$refs.audioplayerEn.currentTime = 0
      }
      if (self.$refs.audioplayerJp) {
        self.$refs.audioplayerJp.pause()
        self.$refs.audioplayerJp.currentTime = 0
      }
    },
    isRegular (val) {
      // eslint-disable-next-line no-useless-escape
      let pattern = new RegExp(/[\p{P}\s]/u)
      if (val && val.match(pattern)) {
        return true
      }
      return false
    }
  }
}
</script>

<style lang="scss">
.DailySentence_child {
  .showDict {
    position: relative;
    &:after {
      position: absolute;
      content: "";
      height: 2px;
      bottom: -5%;
      background: #FF8C8C;
      left: 0;
      width: calc(100% - 0.25rem);
    }
  }
  .enWord {
    margin-right: 0.25rem;
  }
  .jpWord {
    line-height: 2.5;
    margin-right: 0.25rem;
  }
  .showDictJp {
    color: #CE6D39;
    position: relative;
    &:after {
      position: absolute;
      content: "";
      height: 2px;
      bottom: -5%;
      background: #CE6D39;
      left: 0;
      width: calc(100% - 0.25rem);
    }
    ruby {
      rt {
        color: #4B4B4B !important;
      }
    }
  }
}

</style>
